// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
    if(innerWidth > 600){
        const images = document.querySelectorAll('.parallax > img');
        new Ukiyo(images,{
            scale: 1.1,
            speed: 1.5,
            willChange: true
        });
    }


    $(document).ready(function () {

        // Main Nav Dropdown
        $("#primary-nav li").hover(function(){
            $(this).addClass("hover");
            $('ul.submenu',this).fadeIn(200);
        }, function(){
            $(this).removeClass("hover");
            $('ul.submenu',this).fadeOut(200);
        });

    });

    window.onload = function() {
        if(document.getElementById('home')){
            scrollDownAction(40, 'scroll');
        }

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

    document.querySelectorAll('.js-open-menu').forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            document.getElementById('menu').classList.add('show');
        })
    });

    document.querySelectorAll('.js-close-menu').forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            document.getElementById('menu').classList.remove('show');
        })
    });

    $('.slider-home').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        document.querySelector('.slick-number').innerHTML = nextSlide + 1;
    });

    if(document.querySelector('.top-reasons')){
        let tabs = document.querySelectorAll('.top-reasons__item');
        let lastClick = null;
        
        tabs.forEach((tab)=>{
            tab.addEventListener('click', ()=>{
                if(lastClick){
                    lastClick.classList.remove('active');
                }
                tab.classList.add('active');
                lastClick = tab;
            })
        })

        tabs[0].click();
    }

    $('.slider-left').slick({
        dots: false,
        arrows: false,
        asNavFor: '.slider-right'
    });

    $('.slider-right').slick({
        dots: false,
        arrows: true,
        asNavFor: '.slider-left',
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    variableWidth: false,
                    slideToShow: 1,
                    fade: true
                }
            }
        ]
    });

    $('.gallery-quad__slider').slick({
        dots: false,
        arrows: true,
        speed: 700,
        fade: true
    });

    $('.sym-slides').slick({ accessibility:false});

    if(document.getElementsByClassName('js-accordion-title')){        
        document.querySelectorAll('.accordion').forEach((accordion) => {
            accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
                itemHead.addEventListener('click', (e) => {
                    accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
                        if (itemHead.parentNode !== item) item.classList.remove('open');
                    });
                    itemHead.parentNode.classList.toggle('open');
                });
            });
        });
    }

    if(document.querySelector('.form-module-wrapper')){
        let fields = document.querySelectorAll('.form-module__field, .gdpr-wrap, .form-module__submit');
        fields.forEach((field)=>{
            field.classList.add('animate-fade','top');
        })
    }

    if(document.querySelector('.text-modules-wrapper')){
        document.querySelectorAll('.text-modules-wrapper .text-modules').forEach((item)=>{
            item.classList.add('animate-fade','top');
        });
    }

    if(document.querySelector('.global-sitemap')){
        document.querySelectorAll('.global-sitemap').forEach((item)=>{
            item.classList.add('animate-fade','top');
        });
    }

    // GALLERY-FLEX FULLSCRREN MODE
	if (typeof customLightbox !== 'undefined') {
		customLightbox.fullScreen = true;
	}

    $('.awards-slider').slick({
        arrows: true,
        fade:true,
        spedd: 600,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true
                }
            }
        ]
    });

    if(document.querySelector('.slider-awards__dots')){
        let dots_slider = document.querySelectorAll('.slider-awards__dots ul li');
        let lastClick = null;

        $('.awards-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            let slickActive = nextSlide;
            dots_slider.forEach((dot)=>{
                dot.classList.toggle('active',dot.dataset.slick == slickActive);
            })
        });

        dots_slider.forEach((dot)=>{
            dot.addEventListener('click', (e)=>{
                let index = e.target.dataset.slick;

                if(lastClick){
                    lastClick.classList.remove('active');
                }
                dot.classList.add('active');
                $('.awards-slider').slick('slickGoTo', index);

                lastClick = dot;
            })
        })
    }

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 40){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('.menu');
    const isMenuVisible = menu && menu.classList.contains('show');
    const elements = document.querySelectorAll('.privary-navigation__item a');

    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();


    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('.menu');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});